import { Typography } from "antd";

export function Secondary({
  content,
  children,
}: {
  content: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <>
      <div>{content}</div>
      <Typography.Text type="secondary" style={{ fontSize: "75%" }}>
        {children}
      </Typography.Text>
    </>
  );
}
